import { useState, useEffect, useCallback } from 'react';
import { ensureParticipant } from '../services/api';
import type { Participant } from '../types';

const COOKIE_NAME = 'tlr_survey_cookie';
const COOKIE_MAX_AGE_DAYS = 365;

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name: string, value: string, days: number) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};path=/;max-age=${days * 24 * 60 * 60};SameSite=Lax`;
}

export function useParticipant() {
  const [participant, setParticipant] = useState<Participant | null>(null);
  const [cookieId, setCookieId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const ensure = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const existing = getCookie(COOKIE_NAME);
      const { participant: p, cookieId: cid } = await ensureParticipant(existing || undefined);
      setParticipant(p);
      setCookieId(cid);
      setCookie(COOKIE_NAME, cid, COOKIE_MAX_AGE_DAYS);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    ensure();
  }, [ensure]);

  return { participant, cookieId, loading, error, retry: ensure };
}
